export default [

    // riepilogo situazione per utenti abilitati alla gestione
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'1', subMenuActive:'1', title: 'headers.dashboard-title'},
        components: {
            default: () => import(/* webpackChunkName: "root" */ './views/dashboard'),
            'section-header': () => import(/* webpackChunkName: "root" */ './components/section-header')
        }
    },

    {
        path: '/product-status-dashboard',
        name: 'product-status-dashboard',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'1', subMenuActive:'2', title: 'headers.product-status-dashboard'},
        components: {
            default: () => import(/* webpackChunkName: "root" */ './views/product-status-dashboard'),
            'section-header': () => import(/* webpackChunkName: "root" */ './components/section-header')
        }
    },
    {
        path: '/product-last-modified',
        name: 'product-last-modified',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'1', subMenuActive:'3', title: 'headers.product-last-modified'},
        components: {
            default: () => import(/* webpackChunkName: "root" */ './views/product-last-modified'),
            'section-header': () => import(/* webpackChunkName: "root" */ './components/section-header')
        }
    },
    {
        path: '/messages',
        name: 'messages',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'1', subMenuActive:'4', title: 'headers.messages-title'},
        components: {
            default: () => import(/* webpackChunkName: "root" */ './views/messages'),
            'section-header': () => import(/* webpackChunkName: "root" */ './components/section-header')
        }
    },

];